import { useState } from "react";
import { Button, Col, Row, message } from "antd";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { getExamInputs } from "../../../services/exam";
import { getRxViewerUrl, linkVigentExam } from "../../../services/rx";

const VigentExamRx = ({
  form,
  vigentExam,
  admissionPatientExamId,
  setIsVinculating,
  setFileList,
  handleConvertFile,
  fetchInputs,
  actualExam,
}) => {
  const vigentExamId = typeof vigentExam === 'object' ? vigentExam.id : vigentExam;
  const vigentExamData = typeof vigentExam === 'object' ? vigentExam : null;

  const [loadingView, setLoadingView] = useState(false);
  const [loadingUse, setLoadingUse] = useState(false);

  const handlePreviousExamRx = async () => {
    try {
      const newValues = {};
      const response = await getExamInputs({ admissionPatientExamId: vigentExamId });
      ['procedures', 'measurements', 'questions'].forEach(type => {
        if (response[type]) {
          newValues[type] = {};

          response[type].forEach((item) => {
            newValues[type][item.id] = item.result;
            if (type === 'procedures' && item.input_type === 'file' && item.result_id) {
              const file = ({
                id: item.id,
                name: item.document_file_name,
                file: {
                  field: 'document',
                  id: item.result_id,
                  document_type: 'AdmissionProcedureResult',
                  type: item.document_content_type,
                },
              });

              setFileList(fileList => ({
                ...fileList,
                [file.id]: [{
                  uid: '-1',
                  name: file.name || 'archivo',
                  status: 'done',
                  ...file.file,
                }],
              }));

              handleConvertFile(file, item);
            }
          });
        }
      });
      form.setFieldsValue(newValues);
      setIsVinculating(true);
    } catch (error) {
      console.error('Error', error);
    }
  };

  const handleViewImage = async () => {
    setLoadingView(true);
    try {
      const response = await getRxViewerUrl({ admissionPatientExamId: vigentExamId });

      if (response?.status === 200) {
        window.open(response.data?.viewerUrl, "_blank", "noopener,noreferrer");
      } else {
        message.error({
          content: 'No se pudo obtener la URL del visor de imágenes',
          style: {
            marginTop: "35vh",
            fontSize: 16,
          },
        });
      }
    } catch (error) {
      console.error('Error al obtener URL del visor:', error);
      const errorMessage = typeof error === 'string'
        ? error
        : error?.message || error?.msg || 'Error desconocido al obtener URL del visor';
      message.error({
        content: `Error al obtener URL del visor de imágenes: ${errorMessage}`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setLoadingView(false);
    }
  };

  const handleLinkImage = async () => {
    setLoadingUse(true);
    try {
      const response = await linkVigentExam({
        admissionPatientExamId: Number(admissionPatientExamId),
        vigentAdmissionPatientExamId: Number(vigentExamId),
        rxUID: String(vigentExam.rxUID),
        actualWoid: Number(actualExam.extra_data.woid),
      });

      if (response?.status === 'OK' && response?.code === 200) {
        message.success({
          content: 'Examen vigente vinculado exitosamente. La vista se actualizará automáticamente.',
          style: {
            marginTop: "35vh",
            fontSize: 16,
          },
        });

        // Actualizar la vista para reflejar los cambios
        if (fetchInputs) {
          await fetchInputs();
        }
      } else {
        message.error({
          content: response?.msg || 'No se pudo vincular el examen vigente',
          style: {
            marginTop: "35vh",
            fontSize: 16,
          },
        });
      }
    } catch (error) {
      console.error('Error al vincular examen vigente:', error);
      const errorMessage = typeof error === 'string'
        ? error
        : error?.message || error?.msg || 'Error desconocido al vincular el examen vigente';
      message.error({
        content: `Error al vincular examen vigente: ${errorMessage}`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setLoadingUse(false);
    }
  };

  return (
    <>
      <div className="vigent-exam mb-30">
        <div className="vigent-exam-alert mb-15">
          <ExclamationCircleFilled className="icon" />
          <span>
            Este examen se encuentra vigente desde su última visita. <br></br>
            Fecha:
            <strong> {vigentExamData?.dcmDate || '-'} </strong>
            Sucursal:
            <strong> {vigentExamData?.branchOffice || '-'} </strong>
            Criterio:
            <strong> {vigentExamData?.validityCriterion || '-'} </strong>
            Vigencia:
            <strong> {vigentExamData?.validationDate || '-'} días </strong>
          </span>
        </div>
        <Row gutter={15}>
          <Col>
            <Button
              className="cmt-button secondary outline vigent-exam-button"
              type="primary"
              size="small"
              onClick={handleViewImage}
              loading={loadingView}
            >
              Ver DCM Vigente
            </Button>
          </Col>
          <Col>
            <Button
              className="cmt-button primary outline vigent-exam-button"
              type="primary"
              size="small"
              onClick={handleLinkImage}
              loading={loadingUse}
            >
              Utilizar DCM Vigente
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VigentExamRx;